import { useState } from 'react';
import { Grid, Typography, Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DownloadableLoanRatesDialog } from '../quoteSummary/components/downloadableLoanRatesDialog';
import { observer } from 'mobx-react';


const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    width: 'auto',
    padding: '30px 60px',
    border: 'solid 1px #BABEC5',
    marginTop: '-60px',
    maxWidth: '732px',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: '14px',
  },
  quoteCompleteText: {
    fontSize: '18px',
    fontWeight: 400,
    marginTop: 16,
    lineHeight: '175%',
    color: 'rgba(0, 0, 0, 0.6)',
    letterSpacing: '0.15px'
  },
  headerText: {
    fontSize: '36px',
    lineHeight: '124%',
    fontWeight: 400,
    letterSpacing: '0.25px'
  },
  downloadQuoteContainer: {
    display: 'flex',
    position: 'relative',
    width: 'auto',
    padding: '8px 16px',
    marginTop: 30,
    maxWidth: '732px',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: 'solid 1px rgba(30, 70, 32, 1)',
    borderRadius: '14px',
  },
  quoteDownloadText: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '143%',
    color: 'rgba(30, 70, 32, 1)',
    letterSpacing: '0.17px',
    marginLeft: '52px'
  },
  headerDownloadText: {
    fontSize: '16px',
    lineHeight: '150%',
    color: 'rgba(30, 70, 32, 1)',
    fontWeight: 500,
    letterSpacing: '0.15px',
  },
  downloadQuoteButton: {
    color: 'rgba(46, 125, 50, 1)',
    backgroundColor: 'rgba(237, 247, 237, 1)',
    width: 210,
    padding: '6px 16px',
    boxShadow: `0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12)`,
    height: 36
  }
}));
export const QuoteComplete = observer(
  ({
    store
  }: any) => {
    const classes = useStyles();
    const { quoteId } = store
    const [showQuoteDialog, setShowQuoteDialog] = useState(false);
    return (
      <>
        <Grid
          container
          spacing={2}
          className={classes.container}
        >
          <Typography className={classes.headerText}>
            Thank you!
          </Typography>
          <Typography className={classes.quoteCompleteText}>
            Your loan application ID number is {quoteId}. A confirmation email with the signed form has been sent to you.
          </Typography>
          <Typography className={classes.quoteCompleteText}>
            We will notify you via email once the loan application is accepted.
          </Typography>
        </Grid>
        <Grid
          container
          spacing={2}
          className={classes.downloadQuoteContainer}
        >
          <Grid item xs={8}>
            <ul>
              <Box className={classes.headerDownloadText}><Checkmark />Download Quote</Box>
              <li className={classes.quoteDownloadText}>
                Please note that quotes are non-binding and subject to underwriting.
              </li>
            </ul>
          </Grid>
          <Grid item xs={4} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Button onClick={() => setShowQuoteDialog(true)} className={classes.downloadQuoteButton}><DownloadIcon />DOWNLOAD QUOTE</Button>
          </Grid>
          <DownloadableLoanRatesDialog isSubmittedQuote open={showQuoteDialog} onClose={() => setShowQuoteDialog(false)} />
        </Grid>
      </>
    );
  }
);

const DownloadIcon = () => <div style={{ marginRight: 8, display: 'flex' }}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g id="tray-arrow-down">
    <path id="Vector" d="M2 12H4V17H20V12H22V17C22 18.11 21.11 19 20 19H4C2.9 19 2 18.11 2 17V12ZM12 15L17.55 9.54L16.13 8.13L13 11.25V2H11V11.25L7.88 8.13L6.46 9.55L12 15Z" fill="#2E7D32" />
  </g>
</svg></div>

const Checkmark = () => <div style={{ marginRight: 10, display: 'inline' }}>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <g id="CheckCircleOutlined">
      <path id="Vector" d="M15.2082 6.94801L9.16732 12.9888L5.87648 9.70717L4.58398 10.9997L9.16732 15.583L16.5007 8.24967L15.2082 6.94801ZM11.0007 1.83301C5.94065 1.83301 1.83398 5.93967 1.83398 10.9997C1.83398 16.0597 5.94065 20.1663 11.0007 20.1663C16.0607 20.1663 20.1673 16.0597 20.1673 10.9997C20.1673 5.93967 16.0607 1.83301 11.0007 1.83301ZM11.0007 18.333C6.94898 18.333 3.66732 15.0513 3.66732 10.9997C3.66732 6.94801 6.94898 3.66634 11.0007 3.66634C15.0523 3.66634 18.334 6.94801 18.334 10.9997C18.334 15.0513 15.0523 18.333 11.0007 18.333Z" fill="#2E7D32" />
    </g>
  </svg>
</div>